import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { exportCsv, exportXlsx } from "@/lib/exportData";
import { toast } from "sonner";

export function ExportButton({ rows, filename, disabled, testId = "export-btn" }) {
  const handle = (fmt) => {
    if (!rows || rows.length === 0) {
      toast.info("Nothing to export in the current filter.");
      return;
    }
    if (fmt === "csv") exportCsv(rows, filename);
    else exportXlsx(rows, filename);
    toast.success(`Exported ${rows.length} rows as ${fmt.toUpperCase()}`);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled} data-testid={testId}>
          <Download className="w-3.5 h-3.5 mr-1.5" /> Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem onClick={() => handle("csv")} data-testid={`${testId}-csv`}>
          <FileText className="w-3.5 h-3.5 mr-2" /> CSV (.csv)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handle("xlsx")} data-testid={`${testId}-xlsx`}>
          <FileSpreadsheet className="w-3.5 h-3.5 mr-2" /> Excel (.xlsx)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
